import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';

export default {
  name: 'SQRT',
  shortDescription: 'Positive square root of a positive number.',
  category: FunctionCategory.MATH,
  description: 'Returns the positive square root of a positive number.',
  params: [
    {
      name: 'value',
      type: ArgType.nonnegativeNumber,
      description: 'The number for which to calculate the positive square root.',
    },
  ],
  eval: (value: number): number => Math.sqrt(value),
} satisfies EvaluablePrimitiveSpreadsheetFunction;
